<ng-container [formGroup]="_form.form">
    <!-- error messages -->
    <div class="row">
        <div
            class="col-12"
            *ngIf="_form.errors['METRIC']"
        >
            <h6 class="alert alert-warning text-center">
                {{ _form.errors['METRIC'] }}
            </h6>
        </div>
    </div>

    <div
        class="goal-review-container"
        [attr.data-diffitemid]="_selected?.diffItemId || ''"
        *ngIf="!state?.pending?.init"
    >
        <div class="goal-review-header">
            <div class="col-6 d-flex align-items-center">
                <label
                    class="goal-kpi-label"
                    id="metric-label"
                >
                    {{ i18n._9427_GOAL_METRIC | translate }}:
                </label>
                <div class="goal-kpi-value">
                    <ng-container *ngIf="_selected?.goalId; else noMetricId">
                        <div class="goal-kpi-value">
                            {{ _selected.metricName }}
                        </div>
                    </ng-container>

                    <ng-template #noMetricId>
                        <div class="cmps-goal-detail-commitment--kpi-selector">
                            <ng-select
                                [options]="_metricOpts"
                                [placeholder]="
                                    _i18n._9778_SELECT_A_METRIC | translate
                                "
                                [formControlName]="_form.fields.METRIC.name"
                            >
                            </ng-select>
                        </div>
                    </ng-template>
                </div>
            </div>
            <div class="col-6 d-flex justify-content-center">
                <button
                    class="cmps-button--sm btn-goal-history"
                    cmpsButton
                    (click)="_onGoalHistoryClick()"
                >
                    <span cmpsButtonLabel>{{
                        i18n._9438_SEE_GOAL_HISTORY | translate
                    }}</span>
                </button>
            </div>
        </div>
        <div
            class="improvement-info"
            *ngIf="_selected?.goalId || goal?.goalId"
        >
            <div class="left-info">
                <span>
                    {{ i18n._9445_IMPROVEMENT_SINCE_LAST_GOAL | translate }}:
                    <strong
                        *ngIf="
                            goal?.improvementSinceLastGoal ||
                                goal?.improvementSinceLastGoal === 0;
                            else noImprovementSince
                        "
                    >
                        {{ goal.improvementSinceLastGoal | percent: '1.0-1' }}
                    </strong>
                    <ng-template #noImprovementSince>
                        <strong>{{ _i18n._842_N_A | translate }}</strong>
                    </ng-template> </span
                >&nbsp;
                <cmps-icon
                    class="cmps-cdk-fill-green-100"
                    svgIcon="triangle"
                    *ngIf="goal?.improvementSinceLastGoal > 0"
                ></cmps-icon>
                <cmps-icon
                    class="cmps-cdk-fill-red-100"
                    svgIcon="triangle-down"
                    *ngIf="goal?.improvementSinceLastGoal < 0"
                ></cmps-icon>
            </div>
            <div class="right-info">
                <span>
                    {{ i18n._9446_OVERALL_IMPROVEMENT | translate }}:
                    <strong
                        *ngIf="
                            goal?.overallImprovement ||
                                goal?.overallImprovement === 0;
                            else noOverallImprovement
                        "
                    >
                        {{ goal.overallImprovement | percent: '1.0-1' }}
                    </strong>
                    <ng-template #noOverallImprovement>
                        <strong>{{ _i18n._842_N_A | translate }}</strong>
                    </ng-template>
                </span>
                <cmps-icon
                    *ngIf="goal?.overallImprovement > 0"
                    svgIcon="minigoalchartup"
                ></cmps-icon>
                <cmps-icon
                    *ngIf="goal?.overallImprovement < 0"
                    svgIcon="minigoalchartdown"
                ></cmps-icon>
            </div>
        </div>

        <div class="goal-graph-tabs">
            <div class="goal-graph-tab-group">
                <div
                    (click)="activeSubTab = GraphType.VARIANCE"
                    [class.active]="activeSubTab === GraphType.VARIANCE"
                    class="goal-graph-tab"
                >
                    {{ i18n._7398_VARIANCE | translate }}
                </div>
                <div
                    (click)="activeSubTab = GraphType.TREND"
                    [class.active]="activeSubTab === GraphType.TREND"
                    class="goal-graph-tab"
                >
                    {{ i18n._989_TREND | translate }}
                </div>
                <div
                    (click)="activeSubTab = GraphType.GRID"
                    [class.active]="activeSubTab === GraphType.GRID"
                    class="goal-graph-tab"
                >
                    {{ i18n._746_DETAILS | translate }}
                </div>
            </div>

            <div class="goal-graph-radio-group">
                <cmps-button-group
                    [ngModel]="_localPeriodType"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="_onPeriodTypeClick($event)"
                >
                    <button
                        cmpsButtonGroupItem
                        [value]="PeriodType.ROLLING_30"
                    >
                        {{ i18n._714_30_DAY | translate }}
                    </button>
                    <button
                        cmpsButtonGroupItem
                        [value]="PeriodType.DAY"
                    >
                        {{ i18n._202_DAILY | translate }}
                    </button>
                    <button
                        cmpsButtonGroupItem
                        [value]="PeriodType.WEEK"
                    >
                        {{ i18n._203_WEEKLY | translate }}
                    </button>
                    <button
                        cmpsButtonGroupItem
                        [value]="PeriodType.MONTH"
                    >
                        {{ i18n._204_MONTHLY | translate }}
                    </button>
                </cmps-button-group>
            </div>
        </div>

        <div class="goal-graph">
            <div
                class="d-flex align-items-center justify-content-center h-100 w-100"
            >
                <ng-container [ngSwitch]="activeSubTab">
                    <div
                        class="goal-graph-tab-content"
                        *ngSwitchCase="GraphType.TREND"
                    >
                        <div class="goal-chart-container">
                            <cmps-wait-status
                                *ngIf="state?.pending?.data; else showchart1"
                            ></cmps-wait-status>
                            <ng-template #showchart1>
                                <goal-chart-commitment
                                    *ngIf="
                                        !state?.pending?.data &&
                                        (actualTrendData?.length ||
                                            actualVarianceData?.length)
                                    "
                                    [activeMetric]="activeMetric"
                                    [periodType]="_localPeriodType"
                                    [data]="actualTrendData"
                                    [graphType]="activeSubTab"
                                    [goalStatusId]="_selected.statusId"
                                    [showEmptyGraph]="showEmptyGraph"
                                ></goal-chart-commitment>
                            </ng-template>
                        </div>

                        <div class="legend">
                            <div class="btn-leggend">
                                <cmps-icon class="target-line"></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._7457_TARGET_LINE | translate
                                    }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <cmps-icon class="actual-line"></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._7456_ACTUAL_LINE | translate
                                    }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <span class="goal-line"></span
                                ><span class="label-text">
                                    {{ i18n._7458_GOAL_LINE | translate }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <span class="sg-line"></span
                                ><span class="label-text">
                                    {{
                                        i18n._9480_SUPERGROUP_AVERAGE
                                            | translate
                                    }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <cmps-icon
                                    class="dot-active"
                                    svgIcon="flag"
                                ></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._9454_ACTIVE_GOAL | translate
                                    }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <cmps-icon svgIcon="circle"></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._9455_HISTORIC_GOALS | translate
                                    }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <cmps-icon
                                    class="dot"
                                    svgIcon="folder-account"
                                ></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._9457_COMMITMENT_EVENT | translate
                                    }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <cmps-icon
                                    class="dot-multiple"
                                    svgIcon="calendar-text"
                                ></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._9458_MULTIPLE_COACHING_EVENTS
                                            | translate
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>

                    <div
                        class="goal-graph-tab-content"
                        *ngSwitchCase="GraphType.VARIANCE"
                    >
                        <div class="goal-chart-container">
                            <cmps-wait-status
                                *ngIf="state?.pending?.data; else showchart2"
                            ></cmps-wait-status>
                            <ng-template #showchart2>
                                <goal-chart-commitment
                                    *ngIf="
                                        !state?.pending?.data &&
                                        (actualTrendData?.length ||
                                            actualVarianceData?.length)
                                    "
                                    [activeMetric]="activeMetric"
                                    [periodType]="_localPeriodType"
                                    [data]="actualTrendData"
                                    [graphType]="activeSubTab"
                                    [showEmptyGraph]="showEmptyGraph"
                                ></goal-chart-commitment>
                            </ng-template>
                        </div>

                        <div class="legend">
                            <div class="btn-leggend">
                                <cmps-icon class="actual-line"></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._7456_ACTUAL_LINE | translate
                                    }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <cmps-icon class="opp-line"></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._7459_OPPORTUNITY_LINE | translate
                                    }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <cmps-icon
                                    class="dot"
                                    svgIcon="folder-account"
                                ></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._9457_COMMITMENT_EVENT | translate
                                    }}</span
                                >
                            </div>
                            <div class="btn-leggend">
                                <cmps-icon
                                    class="dot-multiple"
                                    svgIcon="calendar-text"
                                ></cmps-icon
                                ><span class="label-text">
                                    {{
                                        i18n._9458_MULTIPLE_COACHING_EVENTS
                                            | translate
                                    }}</span
                                >
                            </div>
                        </div>
                    </div>

                    <div
                        class="goal-graph-tab-content"
                        *ngSwitchCase="GraphType.GRID"
                    >
                        <goal-grid-commitment
                            [activeMetric]="activeMetric"
                            [data]="actualGridData"
                            [periods]="gridPeriods"
                            [componentLength]="0"
                            [metricNames]="metricnames"
                        >
                        </goal-grid-commitment>
                    </div>
                </ng-container>
            </div>
        </div>

        <div class="goal-details-form">
            <div class="row">
                <div class="col-6">
                    <div class="row p-1">
                        <div class="col-5 pr-0">
                            <label>{{
                                i18n._4106_CURRENT_ACTUAL | translate
                            }}</label>
                        </div>
                        <div class="col-7 d-flex align-items-center">
                            <input
                                type="number"
                                class="form-control"
                                [placeholder]="'-'"
                                data-e2e="spinbutton-actual"
                                [readonly]="true"
                                [formControlName]="_form.fields.ACTUAL.name"
                            />
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-5 pr-0">
                            <label>{{
                                i18n._9431__IMPROVEMENT_EXPECTED | translate
                            }}</label>
                        </div>
                        <div class="col-7 d-flex align-items-center">
                            <input
                                type="number"
                                class="form-control"
                                [placeholder]="'%'"
                                data-e2e="spinbutton-improvement"
                                [readonly]="!_isEditing || _reviewingSharedGoal"
                                [formControlName]="
                                    _form.fields.IMPROVEMENT.name
                                "
                            />
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-5 pr-0">
                            <label>{{
                                i18n._9432_GOAL_VALUE | translate
                            }}</label>
                        </div>
                        <div class="col-7 d-flex align-items-center">
                            <input
                                type="number"
                                class="form-control"
                                [placeholder]="'-'"
                                data-e2e="spinbutton-goal"
                                [readonly]="!_isEditing || _reviewingSharedGoal"
                                [formControlName]="_form.fields.GOAL.name"
                            />
                        </div>
                    </div>
                    <div class="row p-1">
                        <div class="col-5 pr-0">
                            <label>{{
                                i18n._9433_START___TO_GOAL | translate
                            }}</label>
                        </div>
                        <div class="col-7 d-flex align-items-center">
                            <input
                                type="number"
                                class="form-control"
                                [placeholder]="'%'"
                                [readonly]="true"
                                data-e2e="spinbutton-startpercenttogoal"
                                [value]="startPercentToGoal"
                            />
                        </div>
                    </div>
                </div>
                <div class="col-6">
                    <div class="row pb-1">
                        <div class="goal-date d-flex justify-content-between">
                            <div class="date-label">
                                <label>{{
                                    i18n._9779_EXPECTED_ACHIEVEMENT_DATE
                                        | translate
                                }}</label>
                            </div>
                            <div class="date-field">
                                <div class="input-group float-left">
                                    <input
                                        class="form-control date-selector"
                                        placeholder="MM-DD-YYYY"
                                        aria-labelledby="goalDate-label"
                                        ngbDatepicker
                                        [minDate]="_minDateStruct"
                                        [placement]="'left'"
                                        [readonly]="
                                            !_isEditing || _reviewingSharedGoal
                                        "
                                        [formControlName]="
                                            _form.fields.DATE.name
                                        "
                                        #dp="ngbDatepicker"
                                    />
                                    <div class="input-group-append">
                                        <button
                                            type="button"
                                            class="btn btn-secondary date-selector-btn"
                                            aria-label="Toggle date picker"
                                            [attr.aria-expanded]="dp.isOpen()"
                                            [disabled]="
                                                !_isEditing ||
                                                _reviewingSharedGoal ||
                                                disabled
                                            "
                                            (click)="
                                                _isEditing &&
                                                    !_reviewingSharedGoal &&
                                                    dp.toggle()
                                            "
                                        >
                                            <cmps-icon
                                                svgIcon="calendar"
                                            ></cmps-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row py-1">
                        <label
                            >{{
                                i18n._9434_DAYS_TO_ACHIEVEMENT | translate
                            }}:&nbsp;
                            <span
                                [style.color]="
                                    _daysToAchievement?.daysToAchievementColor
                                "
                                >{{
                                    _daysToAchievement
                                        ? _daysToAchievement.daysToAchievement
                                        : 0
                                }}</span
                            >
                        </label>
                    </div>
                    <div class="row py-1">
                        <label
                            >{{
                                i18n._9435_TOTAL_DAYS_OPPORTUNITY_ACTIVE
                                    | translate
                            }}: {{ _selected?.oppActiveDays || 0 }}</label
                        >
                    </div>
                    <div class="row">
                        <label
                            >{{ i18n._9436_GOAL_CREATOR | translate }}:
                            {{ _selected?.goalCreator || '-' }}</label
                        >
                    </div>
                    <div class="row">
                        <div class="detail-goal-commitment--wrap-buttons">
                            <ng-container
                                *ngIf="
                                    !hideEditButton &&
                                    !isOriginalWithDraftTrackingIdMap[
                                        _selected.tracking_id
                                    ]
                                "
                            >
                                <button
                                    class="mr-1 mb-1 cmps-button--sm"
                                    cmpsButton
                                    [disabled]="!_form.form.dirty || disabled"
                                    (click)="_onSaveGoalClick()"
                                    *ngIf="
                                        (_isEditing &&
                                            !_reviewingUpdatedSharedGoal &&
                                            !_value.associateToParentFocus) ||
                                        _reviewingSharedGoal
                                    "
                                >
                                    <cmps-icon svgIcon="flag"></cmps-icon>
                                    <span cmpsButtonLabel>{{
                                        saveButtonText
                                    }}</span>
                                </button>
                                <button
                                    class="mr-1 mb-1 cmps-button--sm"
                                    cmpsButton
                                    [disabled]="!_form.form.dirty || disabled"
                                    (click)="_isEditing = true"
                                    *ngIf="
                                        !_isEditing &&
                                        !_reviewingUpdatedSharedGoal &&
                                        !_value.associateToParentFocus
                                    "
                                >
                                    <cmps-icon svgIcon="flag"></cmps-icon>
                                    <span cmpsButtonLabel>{{
                                        i18n._9437_UPDATE_GOAL | translate
                                    }}</span>
                                </button>
                            </ng-container>
                            <button
                                class="mr-1 mb-1 cmps-button--sm"
                                cmpsButtonLabel
                                [disabled]="disabled"
                                (click)="_onAcceptSharedGoalChange()"
                                *ngIf="_reviewingUpdatedSharedGoal"
                            >
                                <cmps-icon svgIcon="flag"></cmps-icon>
                                <span cmpsButtonLabel>{{
                                    i18n._9441_ACCEPT_CHANGES | translate
                                }}</span>
                            </button>
                            <ng-template #cancelordeclinereview>
                                <button
                                    class="mr-1 mb-1 cmps-button--sm"
                                    cmpsButton
                                    data-e2e="button-goal-null"
                                    [disabled]="disabled"
                                    (click)="_onCancelGoalReview()"
                                    *ngIf="
                                        !_reviewingUpdatedSharedGoal;
                                        else decline
                                    "
                                >
                                    <cmps-icon svgIcon="cancel"></cmps-icon>
                                    <span cmpsButtonLabel>{{
                                        i18n._9442_CANCEL_REVIEW | translate
                                    }}</span>
                                </button>
                                <ng-template #decline>
                                    <button
                                        class="mr-1 mb-1 cmps-button--sm"
                                        cmpsButton
                                        data-e2e="button-goal-null"
                                        [disabled]="disabled"
                                        *ngIf="
                                            _reviewingUpdatedSharedGoal;
                                            else cancel
                                        "
                                        (click)="_onDeclineSharedGoalChange()"
                                    >
                                        <cmps-icon svgIcon="cancel"></cmps-icon>
                                        <span cmpsButtonLabel>{{
                                            i18n._9443_DECLINE_CHANGES
                                                | translate
                                        }}</span>
                                    </button>
                                </ng-template>
                            </ng-template>
                        </div>
                        <div class="detail-goal-commitment--wrap-buttons">
                            <button
                                class="mr-1 mb-1 cmps-button--sm btn-filled-grey"
                                cmpsButton
                                [disabled]="
                                    disabled ||
                                    _selected.statusId !== _GoalStatus.DRAFT
                                "
                                (click)="_onDeleteClick()"
                                *ngIf="_selected.statusId === _GoalStatus.DRAFT"
                            >
                                <cmps-icon svgIcon="delete"></cmps-icon>
                                <span cmpsButtonLabel>{{
                                    i18n._9439_DELETE_THIS_GOAL | translate
                                }}</span>
                            </button>
                            <button
                                class="mr-1 mb-1 cmps-button--sm btn-filled-grey"
                                cmpsButton
                                data-e2e="button-goal-null"
                                [disabled]="
                                    disabled ||
                                    _selected.statusId !== _GoalStatus.ACTIVE
                                "
                                (click)="_onCloseClick()"
                                *ngIf="
                                    (_selected.statusId ===
                                        _GoalStatus.ACTIVE ||
                                        _selected.statusId ===
                                            _GoalStatus.PRE_APPROVAL ||
                                        _selected.statusId ===
                                            _GoalStatus.UPDATING) &&
                                    !hideCloseDeleteButton &&
                                    !isOriginalWithDraftTrackingIdMap[
                                        _selected.tracking_id
                                    ]
                                "
                            >
                                <cmps-icon svgIcon="close"></cmps-icon>
                                <span cmpsButtonLabel>{{
                                    i18n._9440_CLOSE_THIS_GOAL | translate
                                }}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- error messages -->
    <div class="row">
        <div
            class="col-12"
            *ngIf="_form.errors['GOAL']"
        >
            <h6 class="alert alert-warning text-center mb-0 mt-3">
                {{ _form.errors['GOAL'] }}
            </h6>
        </div>
        <div
            class="col-12"
            *ngIf="_form.errors['DATE']"
        >
            <h6 class="alert alert-warning text-center mb-0 mt-3">
                {{ _form.errors['DATE'] }}
            </h6>
        </div>
    </div>

    <div
        class="row mt-3 goal-shared-alert"
        *ngIf="isEnableSnackbar"
    >
        <div class="col-12">
            <div
                class="alert-goal"
                (click)="open_popup($event)"
            >
                <cmps-icon svgIcon="information"></cmps-icon>&nbsp;
                <span>{{
                    i18n._9444_THIS_GOAL_IS_BEING_SHARED_ACROSS_OTHER_COMMITMENTS__SEE_THE_OTHER_COMMITMENT_HERE_
                        | translate
                }}</span>
            </div>
        </div>
    </div>
</ng-container>
